import Axios from 'axios'
import {conservationFeesUrls, destinationUrls} from '../urls'
import router from '../../../router'

export default {
  get_all_destinations (context) {
    Axios.get(destinationUrls.getAllDestinations).then(function (response) {
      context.commit('GET_ALL_DESTINATIONS', response.data)
    })
  },
  get_destinations (context, publicId) {
    Axios.get(destinationUrls.getDestinations + publicId).then(function (response) {
      context.commit('GET_DESTINATIONS', response.data)
    })
  },
  get_deleted_destinations (context) {
    Axios.get(destinationUrls.getDeletedDestination).then(function (response) {
      context.commit('GET_DELETED_DESTINATIONS', response.data)
    })
  },
  get_destination (context, publicId) {
    Axios.get(destinationUrls.getDestination + publicId).then(function (response) {
      context.commit('GET_DESTINATION', response.data)
    })
  },
  post_destination (context, data) {
    Axios.post(destinationUrls.postDestination, data).then(function () {
      context.dispatch('get_all_destinations')
    }).catch(function (error) {
      // console.log(error.data)
    })
  },
  update_destination (context, data) {
    Axios.patch(destinationUrls.editDestination, data).then(function () {
      context.dispatch('get_all_destinations')
    }).catch(function (error) {
      context.commit('UPDATE_ERRORS', error.data)
      // console.log(error.data)
    })
  },
  delete_destination (context, data) {
    Axios.post(destinationUrls.deleteDestination, data).then(function (response) {
      context.dispatch('get_all_destinations')
    })
  },
  restoreDestination (context, publicId) {
    Axios.get(destinationUrls.restoreDestination + publicId).then(function (response) {
      alert(response.data.message)
      context.commit('GET_ALL_DESTINATIONS', response.data)
      router.push({
        name: 'Module.Destinations'
      })
    })
  }
}
